export default "__VITE_ASSET__6e03f5fc__"